import React from "react";
import i18next from "i18next";
import TPSearchZone from "./TPSearchZone";
import EABack from '../../../components/common/EABack';

function TPSearch() {

    return (
        <>
          <EABack label={i18next.t("back")} />
          <TPSearchZone/>
        </>
    );
}

export default TPSearch;
